import styled from 'styled-components/macro'

import { Href } from 'components/ui'

export const Wrap = styled.div`
  position: static;
  padding: 2rem 0 0;
  height: calc(100vh - 8rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.6rem;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    height: auto;
  `};

  .cm-s-idea.CodeMirror {
    ${(props) => props.theme.breakpoints.greaterThan('sm')`
      height: 15rem;
    `};
  }
`

export const StyledLink = styled(Href)`
  width: 100%;
  text-align: center;
`
